import CommercialStagingForm from "./CommercialStagingForm"

const OccupiedVacantForm = () => {
    return(
        <CommercialStagingForm unitPrice={15} form_name="Occupied to Vacant" />
    )
}

export default OccupiedVacantForm;